import {
  FETCH_COMBINED_MODES_LOADING,
  FETCH_COMBINED_MODES_SUCCESS,
  FETCH_COMBINED_MODES_FAILURE,
  FETCH_GLOBAL_WORK_MODES_LOADING,
  FETCH_GLOBAL_WORK_MODES_SUCCESS,
  FETCH_GLOBAL_WORK_MODES_FAILURE
} from '../Types/combinedModesTypes';

const initialState = {
  loading: false,
  data: [],
  error: null
};

const combinedModesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COMBINED_MODES_LOADING:
    case FETCH_GLOBAL_WORK_MODES_LOADING:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_COMBINED_MODES_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null
      };

    case FETCH_GLOBAL_WORK_MODES_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null
      };

    case FETCH_COMBINED_MODES_FAILURE:
    case FETCH_GLOBAL_WORK_MODES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default combinedModesReducer;
